import React from 'react'
import { usePostMessageRouter } from './usePostMessageRouter'
import { applyLanguagePreference, persistExplicitUserLocale } from '../i18n/languagePreference'

/**
 * Listens for language change messages from Team Portal and applies i18n switch.
 * Expected payload: { source: 'creately', event: 'teamPortal:changeLanguage', data: { language: string } }
 */
export function useTeamPortalLanguageBridge(enabled: boolean = true) {
  const allowedOrigin = React.useMemo(() => {
    try {
      const portal = (import.meta as any).env?.VITE_TEAM_PORTAL_URL as string | undefined
      if (!portal) return undefined
      return new URL(portal).origin
    } catch {
      return undefined
    }
  }, [])

  usePostMessageRouter({
    enabled,
    allowedOrigin,
    requiredSource: 'creately',
    handlers: {
      'teamPortal:changeLanguage': (payload) => {
        const lang = (payload as { language?: string } | undefined)?.language
        if (typeof lang === 'string' && lang) {
          persistExplicitUserLocale(lang)
          void applyLanguagePreference(lang)
        }
      },
    },
  })
}

